import React, { useCallback } from 'react'
import { Trans } from 'react-i18next'
import { useBoolean } from 'react-use'
import { v4 as uuid4 } from 'uuid'

import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'
import { VariableResultColumn, VariableResultColumnData, VariableSelectFeatureFlag } from '@makyoapp/makyo-common'
import { Column16 } from '@makyoapp/makyo-icon/icon'

import { VariableColumnDataBody } from './VariableColumnData'
import { VariableWrapper } from './VariableWrapper'

export default function VariableColumn({
  id,
  onChange,
  columnTypes = Object.values(ColumnTypes),
  tableId,
  excludeColIds = [],
}: {
  id?: string
  onChange?: (newValue: VariableResultColumn) => void
  columnTypes?: ColumnTypes[]
  tableId?: string
  excludeColIds?: string[]
}) {
  const [show, setShow] = useBoolean(false)
  return (
    <VariableWrapper
      id={id}
      show={show}
      setShow={setShow}
      title={<Trans>Column</Trans>}
      icon={<Column16 width={16} height={16} />}
      defaultHeight={false}
    >
      <VariableColumnBody
        value={{
          id: uuid4(),
          flag: VariableSelectFeatureFlag.Column,
          col: undefined,
        }}
        setShow={setShow}
        columnTypes={columnTypes}
        onChange={onChange}
        tableId={tableId}
        excludeColIds={excludeColIds}
      />
    </VariableWrapper>
  )
}

export function VariableColumnBody({
  onChange,
  columnTypes = Object.values(ColumnTypes),
  setShow,
  value,
  tableId,
  excludeColIds = [],
}: {
  onChange?: (newValue: VariableResultColumn) => void
  columnTypes?: ColumnTypes[]
  setShow: (nextShow: boolean) => void
  value: VariableResultColumn
  tableId?: string
  excludeColIds?: string[]
}) {
  const handleChange = useCallback(
    (v: VariableResultColumnData) => {
      const val: VariableResultColumn = {
        id: v.id,
        flag: VariableSelectFeatureFlag.Column,
        col: v.col,
      }
      onChange?.(val)
    },
    [onChange]
  )
  return (
    <VariableColumnDataBody
      tableId={tableId}
      setShow={setShow}
      columnTypes={columnTypes}
      value={value as unknown as VariableResultColumnData}
      onChange={handleChange}
      noTbl
      excludeColIds={excludeColIds}
    />
  )
}
